import gql from "graphql-tag";
import { PageInfo } from "../types/generalTypes";
import { ProductProps } from "../types/productTypes";

export interface SearchProductVariables {
  limit: number;
  term: string;
  after: string;
  categoryIn?: number[];
}

export interface SearchAutocompleteProductsVariables {
  term?: string;
  limit?: number;
  after?: string;
  categoryIn?: number[];
}

export interface SearchAutocompleteProductsResponse {
  products: {
    nodes: ProductProps[];
    pageInfo: PageInfo;
  };
}

export const searchAutocompleteProducts = gql`
  query searchAutocompleteProducts($term: String, $limit: Int, $after: String, $categoryIn: [Int]) {
    products(first: $limit, after: $after, where: { search: $term, categoryIdIn: $categoryIn, stockStatus: IN_STOCK }) {
      nodes {
        id
        slug
        databaseId
        name
        onSale
        type
        image {
          id
          mediaItemUrl
          sourceUrl(size: _300X210)
        }
        ... on SimpleProduct {
          id
          stockStatus
          stockQuantity
        }
        ... on VariableProduct {
          id
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;

export const searchProducts = gql`
    query searchProducts($term: String, $limit: Int, $after: String, $categoryIn: [Int]) {
    products(first: $limit, after: $after, where: { search: $term, categoryIdIn: $categoryIn, stockStatus: IN_STOCK }) {
      nodes {
        id
        slug
        databaseId
        name
        type
        ... on VariableProduct {
          name
        }
        ... on SimpleProduct {
          name
          stockStatus
          stockQuantity
          onSale
        }
        image {
          id
          mediaItemUrl
          sourceUrl(size: _300X210)
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;
